import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

export let startChatbotServices = coursenum => {
  const root = createRoot(document.getElementById('chatbot_services'))
  root.render(<App coursenum={coursenum} />)
}
